/*** Auth ***/
export const getAuthCredentials = (state) => {
  return {
    username: state.auth.username,
    password: state.auth.password,
    role: "Client",
  };
};
export const getAuth = (state) => {
  const { password, ...rest } = state.auth;

  return rest;
};

export const getUserContext = () => {
  return JSON.parse(sessionStorage.getItem("context"));
};

export const getSession = () => {
  const context = getUserContext();
  return context ? context.session : null;
};

export const getUser = () => getSession().Username;

export const getCurrentAccount = (state) =>
  state.entities.currentAccount || {
    AccountNumber: 0,
    AccountEmail: "",
    AccountName: "",
    advisorName: "",
    advisorFirstLastName: "",
    advisorEmail: "",
    advisorPhone: "",
  };

export const getSavedPersonInfo = (state) => state.entities.personInfo || null;

export const getTexts = (state) => state.entities.texts || null;

export const getTextsLoading = (state) => state.entities.textsLoading || false;

export const getAuthorizations = (state) => state.entities.authorizations || [];

export const getAuthorizationsLoaded = (state) => !!state.entities.authorizationsLoaded;

export const getNotifications = (state) => state.entities.notifications || [];

export const getNotificationsLoaded = (state) => !!state.entities.notificationsLoaded;

export const getNotificationsLoading = (state) => !!state.entities.notificationsLoading;

export const getCounters = (state) => {
  return {
    inProcessOrders: 0,
    authorizations: getAuthorizations(state).length,
    notifications: getNotifications(state).length,
  };
};
